var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Chat',{attrs:{"room":_vm.subject.chat.default,"userModel":_vm.chatUserModel,"message-key":`subject.messages`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }